import { createAsyncThunk } from '@reduxjs/toolkit';
import EmployersApi from 'api/EmployersApi';

import { ErrorResponse } from './ErrorResponse';

export interface Borrower {
  email: string;
  phoneNumber: string;
  firstName: string;
  lastName: string;
  city: string;
  state: string;
  dateOfBirth: string;
}

export interface ValidateEmployerProvidedIncomeData {
  borrower: Borrower;
  employerName: string;
}

export const createValidateEmployerProvidedIncomeThunk = (api: EmployersApi) =>
  createAsyncThunk(
    'employers/validateEmployerProvidedIncome',
    async (employmentData: ValidateEmployerProvidedIncomeData, thunkApi) => {
      try {
        const data = await api.validateEmployerProvidedIncome(employmentData);
        return data;
      } catch (error: unknown) {
        return thunkApi.rejectWithValue((error as ErrorResponse).response);
      }
    },
  );
